import React from 'react';
import { 
  Content 
} from '@backstage/core-components';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const PublicHomePageContent = () => {
  const { t } = useTranslation('serviceRegistry');
  return (
    <Content>
      <Grid item>
        <p>{t('home.welcome', { name: 'Service Registry' })}</p>
      </Grid>
      <Grid item>
        <ul>
          <li>{t('home.signIn')}</li>
          <li>{t('home.register')}</li>
        </ul>
      </Grid>
    </Content>
  );
};
